import React from "react";

export function PageHero({ eyebrow, title, image, largeEyebrow = false }) {
  return (
    <section data-testid="page-hero" className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover editorial-img opacity-[0.18]" />
          <div className="absolute inset-0 bg-gradient-to-b from-ivory via-ivory/85 to-ivory" />
        </div>
      )}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        {largeEyebrow ? (
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight font-semibold text-brand uppercase max-w-5xl">{eyebrow}</h1>
        ) : (
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand mb-6">— {eyebrow}</div>
        )}
        {title && <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] font-light tracking-[-0.02em] text-navy max-w-5xl">{title}</h1>}
      </div>
    </section>
  );
}

export default PageHero;
